'use client';

import { cn } from '@core/utils';
import { useEffect, useState } from 'react';

import SvgTestTube from '../../../__generated__/icon/SvgTestTube';

interface TestMarkProps {
  stageKeyword?: string;
  devKeyword?: string;
}

const SESSION_KEY = 'test-mark';

export const TestMark = ({
  devKeyword = 'dev-',
  stageKeyword = 'st-',
}: TestMarkProps) => {
  const [isShow, setIsShow] = useState(false);
  const [env, setEnv] = useState<'dev' | 'stage' | 'local'>();

  useEffect(() => {
    const { origin } = location;

    const isHidden = sessionStorage.getItem(SESSION_KEY) === 'hidden';

    if (!isHidden) {
      setIsShow(true);
    }

    setEnv(() => {
      if (origin.includes('localhost')) {
        return 'local';
      }
      if (origin.includes(devKeyword)) {
        return 'dev';
      }
      if (origin.includes(stageKeyword)) {
        return 'stage';
      }

      return;
    });
  }, [devKeyword, stageKeyword]);

  return isShow && env ? (
    <button
      className={cn('fixed left-10 top-10 z-50 rounded-pill p-5 opacity-50', {
        'bg-R-500': env === 'dev',
        'bg-Y-500': env === 'stage',
        'bg-B-500': env === 'local',
      })}
      type="button"
      onClick={() => {
        setIsShow(false);
        sessionStorage.setItem(SESSION_KEY, 'hidden');
      }}
    >
      <SvgTestTube className="text-grayscale-50 size-15" name="Test-Tube" />
    </button>
  ) : null;
};
